import styled from 'styled-components';
import theme from 'styles/theme';

export const ModalContainer = styled.div`
  span.green {
    color: ${theme.colors.fontGreen};
  }

  .subCheckbox {
    margin-left: 20px;
  }
`;

export const ModalFooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const OptionSubtitle = styled.p`
  margin-top: 15px;
`;

export const OwnerPermissionsModalContainer = styled.div`
  .formula-radio-title {
    margin-top: 24px;
  }
`;

export const TooltipContent = styled.span`
  white-space: pre-line;
`;
